import React, { useEffect, useState } from "react";
import "./similartaskdetail.scss";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate, useParams } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { useWeb3React } from "@web3-react/core";
import SimilarTasks from "./SimilarTasks";
import copy from "copy-to-clipboard";
// import { toast } from "react-toastify"; 
import Loader from "../../hooks/loader";
import { useSocket } from "../../contexts/SocketContext";
import getDollarValueOfToken from "../../services/tokenPrice_usd";

import useParticipate from "../../hooks/similarTaskDetail/useParticipate";
import useFetchTaskData from "../../hooks/similarTaskDetail/useFetchTaskData";
import useProofSubmit from "../../hooks/similarTaskDetail/useProofSubmit";
import useDisputeSubmit from "../../hooks/similarTaskDetail/useDisputeSubmit";
import FileNameFormatter from "./FileNameFormatter";
import useCreateDispute from "../../hooks/similarTaskDetail/useCreateDispute";
import TaskCard from "./TaskCard";
import { uploadProofOnIPFS } from "../../hooks/IPFS/UploadProofOnIPFS";
import Reportmodal from "./Reportmodal";
import CustomToast from '../../components/CustomToast';
import Environment from "../../utils/Environment";


const Similartaskdetail = () => {

    const { account } = useWeb3React();

    const [loader, setLoader] = useState(false);
    const [loaderMessage, setLoaderMessage] = useState("");

    const [isCopied, setIsCopied] = useState(false);
    const [dollarVal, setDollorVal] = useState(0);

    const { id } = useParams(); // Get the task ID from the URL

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [taskIds, setTaskIds] = useState();
    const [show1, setShow1] = useState(false);
    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);
    const [message, setMessage] = useState("");
    // const [apiReload, setApiReload] = useState(false);
    const [disputeChec, setDisputeCheck] = useState(false);
    const [show2, setShow2] = useState(false);
    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const [show3, setShow3] = useState(false);
    const handleClose3 = () => setShow3(false);
    const handleShow3 = () => setShow3(true);

    const socket = useSocket();
    const [show4, setShow4] = useState(false);
    const handleClose4 = () => setShow4(false);

    const [show5, setShow5] = useState(false);
    const handleClose5 = () => setShow5(false);
    const handleShow5 = () => setShow5(true);

    const [show6, setShow6] = useState(false);
    const handleClose6 = () => setShow6(false);

    const [showdispute, setShowDispute] = useState(false);
    const handleCloseDispute = () => setShowDispute(false);

    // const [showdisputefee, setShowDisputeFee] = useState(false);
    // const handleCloseDisputeFee = () => setShowDisputeFee(false);

    const [epochTime, setEpochTime] = useState(0);

    // Social share states
    const [copied, setCopied] = useState(false);
    const [url, setUrl] = useState('');

    const [show22, setShow22] = useState(false);
    const handleClose22 = () => setShow22(false);
    const [taskData, setTaskData] = useState(null); // State for storing fetched task data
    const [file, setFile] = useState(null);
    const [filePreview, setFilePreview] = useState(null);
    console.log(taskData, "taskDatataskDatataskData");

    const [showReport, setShowReport] = useState(false);

    const handleCloseReport = () => setShowReport(false);
    const handleShowReport = () => setShowReport(true);

    const { curruntStatus, isWinner, fetchTaskData } = useFetchTaskData(taskData, id, setTaskData, setLoader, account)
    const { uniqueCode, uniqueStatus, userId, participate, fetchPrticipateData } = useParticipate(fetchTaskData, handleClose, setLoader, taskIds, handleShow1, taskData, id);
    const { handleSubmit, handleFileChange } = useProofSubmit(
        setFilePreview,
        setFile,
        file,
        taskData,
        message,
        id, // Assuming task ID is 1
        setLoader,
        uniqueCode,
        fetchPrticipateData,
        fetchTaskData,
        handleClose2,
        handleShow3
    );

    const { handleSubmitDispute } = useDisputeSubmit(
        setFilePreview,
        setFile,
        file, taskData, message, id, setLoader, fetchTaskData, handleClose2, handleShow5
    );

    const { createDispute } = useCreateDispute(id, account, taskData, setLoader, fetchTaskData, taskData?.participation?.proofIpfsHash);

    const onClickCopy = async (txt) => {
        try {
            copy(txt);
            setIsCopied(true);
            setTimeout(() => {
                setIsCopied(false);
            }, 2000);
        } catch (err) {
            console.error("Failed to copy: ", err);
        }
    };

    const errorMsg = () => {
        // toast.error("Connect Wallet!");
        CustomToast.show('error', 'Error!', 'Connect Wallet!')

    };

    const proofCall = async () => {
        console.log("asdfdsfasdfasfaadsfs");
        try {
            // debugger
            setLoader(true);
            const res = await uploadProofOnIPFS(account, taskData, message, file);
            console.log(res, "ipfs res");
            // return
            if (res) {
                handleSubmit(res[0]);
            }
        } catch (error) {
            setLoader(false);
            // toast?.error(error);
            CustomToast.show('error', 'Error!', error?.message)
        }
    };





    useEffect(() => {
        if (socket) {
            // Handle the 'NOTIFICATION_ALERT' event here
            socket.on('NOTIFICATION_ALERT', (event) => {
                window.location.reload();
            });
        }

    }, [socket]);
    useEffect(() => {

        async function tokenPrice() {
            let dollorValue = await getDollarValueOfToken(taskData)
            setDollorVal(dollorValue)
        }
        if (taskData) {
            tokenPrice()
        }
    }, [taskData]);

    //  ================================= Social Share ========================================== //

    const handleCopyURL = async (e) => {
        e.preventDefault()

        copy(url, {
            debug: true,
            message: 'Press Ctrl+C to copy the URL',
        });
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
    };

    const twitterPost = () => {
        // const taskTitle = taskCreated?.title || "An Exciting Task";
        const tweetUrl = `${Environment?.siteURL}/similartaskdetail/${taskData?.id}`;
        const tweetText = `✅ I just submitted my work on Tasks! You can participate too! Complete tasks, earn rewards, and be part of the community. Check it out here:`
        const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}&url=${encodeURIComponent(tweetUrl)}`;

        window.open(twitterShareUrl, "_blank");
        console.log(twitterShareUrl, "social");
    };

    const telegramPost = (e) => {
        e.preventDefault()
        // const taskTitle = taskData?.title || "An Exciting Task";
        const taskUrl = `${Environment?.siteURL}/similartaskdetail/${taskData?.id}`;
        const message = `✅ I just submitted my work on Tasks! You can participate too! Complete tasks, earn rewards, and be part of the community. Check it out here: ${taskUrl}`;

        const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(taskUrl)}&text=${encodeURIComponent(message)}`;

        window.open(telegramUrl, "_blank");
        console.log(telegramUrl, "social");
    };

    const facebookPost = () => {
        const taskUrl = `${Environment?.siteURL}/similartaskdetail/${taskData?.id}`;
        const message = `✅ I just created a new task! Come check it out and join to earn rewards if you’re interested! Check it out here: ${taskUrl}`;
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(taskUrl)}&text=${encodeURIComponent(message)}`;

        window.open(facebookUrl, "_blank");
        console.log(facebookUrl, "social");
    };

    const emailPost = () => {
        const taskUrl = `${Environment?.siteURL}/similartaskdetail/${taskData?.id}`;

        const emailSubject = encodeURIComponent(taskData?.title);
        const emailBody = encodeURIComponent(
            `✅ I just submitted my work on Tasks! \n\n` +
            `You can participate too! Complete tasks, earn rewards, and be part of the community. \n\n` +
            `Check it out here: ${taskUrl}`
        );

        const emailUrl = `mailto:?subject=${emailSubject}&body=${emailBody}`;

        window.open(emailUrl, "_blank");
        console.log(emailUrl, "social");
    };



    //  ================================= Social Share ========================================== //

    useEffect(() => {
        if (socket) {
            socket.on('NOTIFICATION_ALERT', (event) => {
                window.location.reload();
            });
        }

    }, [socket]);

    useEffect(() => {
        async function tokenPrice() {
            let dollorValue = await getDollarValueOfToken(taskData)
            setDollorVal(dollorValue)
        }
        if (taskData) {
            tokenPrice()
        }
    }, [taskData]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setUrl(window.location.href); // Safely set the URL
        }
    }, []);

    useEffect(() => {
        const timeInSeconds = Math.floor(Date.now() / 1000);
        setEpochTime(timeInSeconds);
    }, []);

    return (
        <>
            {loader && <Loader />}
            {/* <Navbar /> */}
            <section className="similartaskdetail">
                <img
                    src="/assets/importantassets/backshade.png"
                    alt="backshade"
                    className="backshade"
                />
                <img
                    src="/assets/importantassets/backshadembl.png"
                    alt="backshade"
                    className="backshadembl d-none"
                />
                <div className="custom-container">
                    <p className="toppara">
                        <span className="light">Home </span>/{" "}
                        {taskData?.tasksCategory?.categoryName}
                    </p>
                    {taskData?.currency === "TASK" ? <div className="paid-elem">
                        <h6>Paid with <span>$TASK</span></h6>
                    </div> : null}
                    <div className="detailmain">
                        <div className="detailsleft">
                            {/* <span className="statusmain">
                                <span className="statuscircle"></span>
                                <p className="statuspara">PARTICIPATED</p>
                            </span> */}
                            <h4 className="detailhead">{taskData?.title}</h4>
                            <div className="parentsdiv">
                                {taskData?.serviceType === "physical" && (
                                    <div className="left">
                                        <p className="locationparaaaaaaa">Location</p>
                                        <div className="boxxxxxx">
                                            {taskData?.locations &&
                                                Object.entries(taskData.locations).map(
                                                    ([country, cities]) => (
                                                        <p key={country}>
                                                            {country}, {cities?.join(", ")}
                                                        </p>
                                                    )
                                                )}
                                        </div>
                                    </div>
                                )}
                                {taskData?.deliveryFormat?.length > 0 && (
                                    <div className="formate">
                                        <h3 className="formatehead ">Delivery Format</h3>
                                        <div className="mainbuttons ">
                                            {taskData?.deliveryFormat?.map((item) => (
                                                <button>{item}</button>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="mainheadingggg">
                                <h2>Task Details</h2>
                            </div>
                            <div
                                className="detailpara ql-editor-new"
                                // Uncomment the next line if using DOMPurify
                                // dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                                dangerouslySetInnerHTML={{ __html: taskData?.description }}
                            />
                            <div className="mainheadingggg"></div>
                            {taskData?.requirements && (
                                <>
                                    <h2>Task Requirements</h2>
                                    <div
                                        className="detailpara ql-editor-new"
                                        // Uncomment the next line if using DOMPurify
                                        // dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                                        dangerouslySetInnerHTML={{ __html: taskData?.requirements }}
                                    />
                                </>
                            )}

                            {taskData?.additionalRequest && (
                                <div className="mainheadingggg forbrdrrrrr">
                                    <h2>Additional Requests</h2>
                                    <div
                                        className="detailpara ql-editor-new"
                                        // Uncomment the next line if using DOMPurify
                                        // dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                                        dangerouslySetInnerHTML={{
                                            __html: taskData?.additionalRequest,
                                        }}
                                    />
                                </div>
                            )}

                            {
                                taskData?.winnerSelected == false && (Math.floor(new Date(taskData?.endTime).getTime() / 1000) > epochTime) && (taskData?.user?.walletAddress !== account?.toLocaleLowerCase()) ?
                                    <>
                                        {
                                            account ?
                                                <>
                                                    {
                                                        !taskData?.hasReported ?
                                                            <button onClick={handleShowReport} className="reportpara">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M3.34062 3.90628C3.27339 3.96456 3.21937 4.03652 3.18218 4.11736C3.145 4.1982 3.1255 4.28605 3.125 4.37503V17.5C3.125 17.6658 3.19085 17.8248 3.30806 17.942C3.42527 18.0592 3.58424 18.125 3.75 18.125C3.91576 18.125 4.07473 18.0592 4.19194 17.942C4.30915 17.8248 4.375 17.6658 4.375 17.5V14.0446C6.46797 12.3914 8.27109 13.2828 10.3477 14.311C11.6289 14.9446 13.0086 15.6274 14.4883 15.6274C15.5766 15.6274 16.718 15.2563 17.9117 14.2211C17.979 14.1628 18.033 14.0909 18.0702 14.01C18.1073 13.9292 18.1268 13.8413 18.1273 13.7524V4.37503C18.1271 4.25506 18.0923 4.13771 18.0271 4.03699C17.9619 3.93627 17.8692 3.85643 17.7598 3.80701C17.6505 3.75758 17.5293 3.74066 17.4106 3.75826C17.292 3.77587 17.1809 3.82725 17.0906 3.90628C14.9031 5.79924 13.05 4.88206 10.9023 3.81878C8.67734 2.71565 6.15469 1.46799 3.34062 3.90628ZM16.875 13.4571C14.782 15.1102 12.9789 14.218 10.9023 13.1907C8.94922 12.2258 6.77656 11.1492 4.375 12.5344V4.67112C6.46797 3.01799 8.27109 3.9094 10.3477 4.93674C12.3008 5.90159 14.4742 6.97815 16.875 5.59299V13.4571Z" fill="#013159" />
                                                                </svg>
                                                                Report an issue
                                                            </button>
                                                            :
                                                            <button className="reportpara">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M3.34062 3.90628C3.27339 3.96456 3.21937 4.03652 3.18218 4.11736C3.145 4.1982 3.1255 4.28605 3.125 4.37503V17.5C3.125 17.6658 3.19085 17.8248 3.30806 17.942C3.42527 18.0592 3.58424 18.125 3.75 18.125C3.91576 18.125 4.07473 18.0592 4.19194 17.942C4.30915 17.8248 4.375 17.6658 4.375 17.5V14.0446C6.46797 12.3914 8.27109 13.2828 10.3477 14.311C11.6289 14.9446 13.0086 15.6274 14.4883 15.6274C15.5766 15.6274 16.718 15.2563 17.9117 14.2211C17.979 14.1628 18.033 14.0909 18.0702 14.01C18.1073 13.9292 18.1268 13.8413 18.1273 13.7524V4.37503C18.1271 4.25506 18.0923 4.13771 18.0271 4.03699C17.9619 3.93627 17.8692 3.85643 17.7598 3.80701C17.6505 3.75758 17.5293 3.74066 17.4106 3.75826C17.292 3.77587 17.1809 3.82725 17.0906 3.90628C14.9031 5.79924 13.05 4.88206 10.9023 3.81878C8.67734 2.71565 6.15469 1.46799 3.34062 3.90628ZM16.875 13.4571C14.782 15.1102 12.9789 14.218 10.9023 13.1907C8.94922 12.2258 6.77656 11.1492 4.375 12.5344V4.67112C6.46797 3.01799 8.27109 3.9094 10.3477 4.93674C12.3008 5.90159 14.4742 6.97815 16.875 5.59299V13.4571Z" fill="#013159" />
                                                                </svg>
                                                                Reported
                                                            </button>
                                                    }
                                                </>
                                                :
                                                <button onClick={handleShowReport} className="reportpara">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <path d="M3.34062 3.90628C3.27339 3.96456 3.21937 4.03652 3.18218 4.11736C3.145 4.1982 3.1255 4.28605 3.125 4.37503V17.5C3.125 17.6658 3.19085 17.8248 3.30806 17.942C3.42527 18.0592 3.58424 18.125 3.75 18.125C3.91576 18.125 4.07473 18.0592 4.19194 17.942C4.30915 17.8248 4.375 17.6658 4.375 17.5V14.0446C6.46797 12.3914 8.27109 13.2828 10.3477 14.311C11.6289 14.9446 13.0086 15.6274 14.4883 15.6274C15.5766 15.6274 16.718 15.2563 17.9117 14.2211C17.979 14.1628 18.033 14.0909 18.0702 14.01C18.1073 13.9292 18.1268 13.8413 18.1273 13.7524V4.37503C18.1271 4.25506 18.0923 4.13771 18.0271 4.03699C17.9619 3.93627 17.8692 3.85643 17.7598 3.80701C17.6505 3.75758 17.5293 3.74066 17.4106 3.75826C17.292 3.77587 17.1809 3.82725 17.0906 3.90628C14.9031 5.79924 13.05 4.88206 10.9023 3.81878C8.67734 2.71565 6.15469 1.46799 3.34062 3.90628ZM16.875 13.4571C14.782 15.1102 12.9789 14.218 10.9023 13.1907C8.94922 12.2258 6.77656 11.1492 4.375 12.5344V4.67112C6.46797 3.01799 8.27109 3.9094 10.3477 4.93674C12.3008 5.90159 14.4742 6.97815 16.875 5.59299V13.4571Z" fill="#013159" />
                                                    </svg>
                                                    Report an issue
                                                </button>
                                        }
                                    </>
                                    :
                                    <button disabled className="reportpara disabled" style={{ cursor: 'not-allowed', opacity: '0.3' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M3.34062 3.90628C3.27339 3.96456 3.21937 4.03652 3.18218 4.11736C3.145 4.1982 3.1255 4.28605 3.125 4.37503V17.5C3.125 17.6658 3.19085 17.8248 3.30806 17.942C3.42527 18.0592 3.58424 18.125 3.75 18.125C3.91576 18.125 4.07473 18.0592 4.19194 17.942C4.30915 17.8248 4.375 17.6658 4.375 17.5V14.0446C6.46797 12.3914 8.27109 13.2828 10.3477 14.311C11.6289 14.9446 13.0086 15.6274 14.4883 15.6274C15.5766 15.6274 16.718 15.2563 17.9117 14.2211C17.979 14.1628 18.033 14.0909 18.0702 14.01C18.1073 13.9292 18.1268 13.8413 18.1273 13.7524V4.37503C18.1271 4.25506 18.0923 4.13771 18.0271 4.03699C17.9619 3.93627 17.8692 3.85643 17.7598 3.80701C17.6505 3.75758 17.5293 3.74066 17.4106 3.75826C17.292 3.77587 17.1809 3.82725 17.0906 3.90628C14.9031 5.79924 13.05 4.88206 10.9023 3.81878C8.67734 2.71565 6.15469 1.46799 3.34062 3.90628ZM16.875 13.4571C14.782 15.1102 12.9789 14.218 10.9023 13.1907C8.94922 12.2258 6.77656 11.1492 4.375 12.5344V4.67112C6.46797 3.01799 8.27109 3.9094 10.3477 4.93674C12.3008 5.90159 14.4742 6.97815 16.875 5.59299V13.4571Z" fill="#013159" />
                                        </svg>
                                        Report an issue
                                    </button>
                            }
                        </div>
                        <div className="detailsright">
                            <TaskCard taskData={taskData} curruntStatus={curruntStatus} id={id} uniqueStatus={uniqueStatus} uniqueCode={uniqueCode} fetchTaskData={fetchTaskData}
                                setTaskIds={setTaskIds} handleShow={handleShow} handleShow2={handleShow2} userId={userId} errorMsg={errorMsg}
                                isWinner={isWinner} createDispute={createDispute} setLoader={setLoader} />
                        </div>
                    </div>
                    <div className="similartop">
                        <h4 className="similarhead">Similar Tasks</h4>
                        <Link to="/latesttask">
                            <button className="similarbtn">View All Tasks</button>
                        </Link>
                    </div>
                </div >
                <SimilarTasks
                    taskId={id}
                    categoryId={taskData?.categoryId}
                    category={taskData?.tasksCategory?.categoryName}
                    handleShow={handleShow}
                />
            </section >
            {dollarVal > 10 ?
                <Modal className="newmodal" show={show} onHide={handleClose} centered>

                    <Modal.Body>

                        <div className="maincontent">
                            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="71" viewBox="0 0 70 71" fill="none">
                                <rect x="5" y="5.5" width="60" height="60" stroke="#013159" stroke-width="2" />
                                <rect x="24" y="19" width="2" height="22" transform="rotate(-90 24 19)" fill="#013159" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M35 19H37L37 12H35L35 19ZM35 58H37L37 53H44H46V51V36V34H44H26V17H24V34V36H26L44 36V51H37H35H24V53H35L35 58Z" fill="#013159" />
                            </svg>
                            <h3 className="upperhead">Important: Dispute Initiation Fee</h3>
                            <p className="para">Since the task value is high, any disputes will be carefully reviewed by a jury of 15 DOP Oracles to ensure a fair and accurate resolution. To support this process, initiating a dispute will require a fee of $400.</p>
                            <p className="para">
                                Please take this into consideration before participating in a task, as you may incur this expense if a dispute arises</p>
                            <button className="confirmbutton" onClick={() => {
                                participate();
                            }}>Confirm Participation</button>
                            <button className="canclebutton" onClick={handleClose}>Cancel</button>
                        </div>
                    </Modal.Body>

                </Modal>
                :
                <Modal
                    show={show}
                    onHide={handleClose}
                    className="modal_main dcscysysbc"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Participate</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="modal1">
                            <img className="imgqus" src="\assets\createtask\qusmark.png" />
                            <h1>
                                Are you sure you want to participate <br /> in this task?
                            </h1>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="modal_footer">
                            <button className="cancelbutton" onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={() => {
                                    participate();
                                }}
                                className="surebutton"
                            >
                                Yes, I’m Sure
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
            }

            <Modal show={show1} onHide={handleClose1} className="modal_main" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal2">
                        <img className="imgqus" src="\assets\createtask\tick.png" />
                        <h1>Your participation has been registered.</h1>
                        <div className="codediv">
                            <p>Unique Secret Code:</p>
                            <h2>
                                {uniqueCode}{" "}
                                {isCopied ? (
                                    " Copied"
                                ) : (
                                    <svg
                                        onClick={() => onClickCopy(uniqueCode)}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="21"
                                        height="20"
                                        viewBox="0 0 21 20"
                                        fill="none"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <path
                                            d="M17.375 2.65625H7.375C7.25068 2.65625 7.13145 2.70564 7.04354 2.79354C6.95564 2.88145 6.90625 3.00068 6.90625 3.125V6.40625H3.625C3.50068 6.40625 3.38145 6.45564 3.29354 6.54354C3.20564 6.63145 3.15625 6.75068 3.15625 6.875V16.875C3.15625 16.9993 3.20564 17.1185 3.29354 17.2065C3.38145 17.2944 3.50068 17.3438 3.625 17.3438H13.625C13.7493 17.3438 13.8685 17.2944 13.9565 17.2065C14.0444 17.1185 14.0938 16.9993 14.0938 16.875V13.5938H17.375C17.4993 13.5938 17.6185 13.5444 17.7065 13.4565C17.7944 13.3685 17.8438 13.2493 17.8438 13.125V3.125C17.8438 3.00068 17.7944 2.88145 17.7065 2.79354C17.6185 2.70564 17.4993 2.65625 17.375 2.65625ZM13.1562 16.4062H4.09375V7.34375H13.1562V16.4062ZM16.9062 12.6562H14.0938V6.875C14.0938 6.75068 14.0444 6.63145 13.9565 6.54354C13.8685 6.45564 13.7493 6.40625 13.625 6.40625H7.84375V3.59375H16.9062V12.6562Z"
                                            fill="#013159"
                                        />
                                    </svg>
                                )}
                            </h2>
                        </div>

                        <h3>
                            Please include this code in your proof of work. Verification of
                            successful completion will not be possible without it.
                        </h3>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="modal_footer">
                        <button className="surebutton" onClick={handleClose1}>
                            OK
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={show2} onHide={handleClose2} className="modal_main" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Submit Proof</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h6 className="dont-foreget-text">
                        Don't forget to provide the unique secret code you received when you
                        accepted this task, A successful completion of the task cannot be
                        verified without this code.
                    </h6>
                    <div className="modal3">
                        <h1>Message</h1>
                        <Form.Control
                            as="textarea"
                            placeholder="Enter your message here..."
                            style={{ height: "100px" }}
                            onChange={(e) => setMessage(e.target.value)}
                        />
                        <h1>Upload File</h1>
                        <div className="modal3_inner">
                            <h2>{filePreview ? "Selected File" : "Select File here"}</h2>
                            <p style={{ fontSize: "12px" }}>
                                {filePreview ? (
                                    <a
                                        href={filePreview}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FileNameFormatter fileName={file?.[0]?.name} />
                                    </a>
                                ) : (
                                    "Files Supported : " + taskData?.deliveryFormat?.join(", ") // Display the supported formats dynamically
                                )}
                            </p>
                            <input
                                type="file"
                                accept={[
                                    ...["jpg", "jpeg", "png", "webp"],
                                    ...(taskData?.deliveryFormat || []), // Preserve existing deliveryFormat values
                                ]
                                    ?.map((format) =>
                                        format === "jpeg" ? "image/jpeg" : `.${format}`
                                    )
                                    ?.join(", ")} // Dynamic accept based on deliveryFormat
                                // multiple // <-- This enables selecting multiple files
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                                id="file-upload"
                            />
                            <label htmlFor="file-upload" className="ChooseFile cppp">
                                Select File
                            </label>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="modal_footer">
                        <button className="cancelbutton" onClick={handleClose2}>
                            CANCEL
                        </button>
                        <button
                            className="surebutton"
                            onClick={() => {
                                if (disputeChec) {
                                    handleSubmitDispute();
                                } else {
                                    if (!message && !file) {
                                        CustomToast?.show('error', 'Error!', 'The proof message and file are missing!');
                                        return;
                                    }

                                    if (!message) {
                                        CustomToast?.show('error', 'Error!', 'Proof messege is required!');
                                        return;
                                    }

                                    if (!file) {
                                        CustomToast?.show('error', 'Error!', 'Proof file is required!');
                                        return;
                                    }

                                    if (file) {
                                        proofCall();
                                    } else {
                                        console.log("file not found", file);

                                    }
                                }
                            }}
                        >
                            SUBMIT
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
            {/* <Modal show={show2} onHide={handleClose2} className="modal_main" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Submit Proof</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal3">
                        <h1>Upload File</h1>
                        <div className="modal3_inner">
                            <h2>Select File here</h2>
                            <p>Files Supported : PDF, TEXT, DOC, DOCX</p>
                            <button className="ChooseFile">Choose File</button>
                        </div>
                        <h1>Message</h1>

                        <Form.Control
                        onClick={(e)=>{setMessage(e.target.value)}}
                            as="textarea"
                            placeholder="Enter your message here..."
                            style={{ height: '100px' }}
                        />

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="modal_footer">
                        <button className="cancelbutton" onClick={handleClose2}>CANCEL</button>
                        <button className="surebutton">SUBMIT</button>
                    </div>
                </Modal.Footer>
            </Modal> */}

            <Modal show={show3} onHide={handleClose3} className="modal_main createtask-modal" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal4">
                        <img className="imgqus" src="\assets\createtask\tick.png" />
                        <h1>Task Submitted!</h1>
                        <p>Your work has been submitted!</p>
                        <p>

                            Once the task reaches the due date, the task creator will have 24 hours to select the winner.
                            <br /><br />

                            Stay tuned and spread the word <br />
                            so your friends can join too!
                        </p>
                    </div>
                    <div className="social-area">
                        <h6>Share on</h6>
                        <div className="social-icons">
                            <div className="single-icon" onClick={() => twitterPost()}>
                                <a href="https://x.com/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                    <path d="M15.62 1.875H18.3767L12.3542 8.75833L19.4392 18.125H13.8917L9.54667 12.4442L4.575 18.125H1.81667L8.25834 10.7625L1.46167 1.875H7.15L11.0775 7.0675L15.62 1.875ZM14.6525 16.475H16.18L6.32 3.43833H4.68084L14.6525 16.475Z" fill="#013159" />
                                </svg></a>
                                <p>X</p>
                            </div>
                            <div className="single-icon" onClick={() => facebookPost()}>
                                <a href="https://www.facebook.com/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                    <path d="M12.4654 20V10.8777H15.5262L15.9854 7.32156H12.4654V5.05147C12.4654 4.0222 12.7501 3.32076 14.2277 3.32076L16.1093 3.31999V0.13923C15.7839 0.0969453 14.667 0 13.367 0C10.6524 0 8.7939 1.65697 8.7939 4.69927V7.32156H5.72388V10.8777H8.7939V20H12.4654Z" fill="#013159" />
                                </svg></a>
                                <p>Facebook</p>
                            </div>
                            <div className="single-icon" >
                                <a href="https://t.me/" onClick={(e) => telegramPost(e)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                        <path d="M15.8843 9.02378C16.4721 8.41847 17.0557 7.00606 14.6064 8.72112C12.3184 10.3427 10.0149 11.9408 7.69624 13.5154C7.34316 13.6798 6.96144 13.7691 6.57403 13.7777C6.18663 13.7864 5.80152 13.7143 5.44184 13.5659C3.97227 13.1119 2.25671 12.5066 2.25671 12.5066C2.25671 12.5066 1.08532 11.7488 3.09053 10.9417C3.09053 10.9417 11.5682 7.35916 14.5084 6.09699C15.6351 5.59256 19.457 3.97839 19.457 3.97839C19.457 3.97839 21.2215 3.27109 21.0746 4.98725C21.0256 5.69345 20.6337 8.16735 20.2418 10.8408C19.653 14.6252 19.0161 18.7637 19.0161 18.7637C19.0161 18.7637 18.9182 19.9239 18.0854 20.1257C17.194 20.1101 16.3327 19.7908 15.6361 19.2177C15.4402 19.0663 11.9612 16.7953 10.6865 15.6856C10.5568 15.5951 10.4514 15.4724 10.3802 15.3287C10.3091 15.1851 10.2742 15.0252 10.2791 14.864C10.284 14.7028 10.3285 14.5456 10.4082 14.4067C10.488 14.268 10.6005 14.1522 10.7355 14.0703C12.4838 12.4231 14.2003 10.7406 15.8843 9.02378Z" fill="#013159" />
                                    </svg>
                                </a>
                                <p>Telegram</p>
                            </div>
                            <div className="single-icon" onClick={() => emailPost()}>
                                <a href="mailto:your@email.com"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <g clip-path="url(#clip0_4684_9370)">
                                        <path d="M11.6714 12.2536C11.1739 12.5853 10.5959 12.7606 10 12.7606C9.40414 12.7606 8.82617 12.5853 8.32859 12.2536L0.133164 6.78977C0.0876953 6.75945 0.0433984 6.72785 0 6.69535V15.6484C0 16.6748 0.833008 17.4895 1.84113 17.4895H18.1588C19.1853 17.4895 20 16.6565 20 15.6484V6.69531C19.9565 6.72789 19.9121 6.75957 19.8665 6.78992L11.6714 12.2536Z" fill="#013159" />
                                        <path d="M0.783203 5.81414L8.97863 11.278C9.28887 11.4848 9.64441 11.5882 9.99996 11.5882C10.3555 11.5882 10.7111 11.4848 11.0214 11.278L19.2168 5.81414C19.7072 5.48738 20 4.94051 20 4.35027C20 3.33539 19.1743 2.50977 18.1595 2.50977H1.84051C0.825664 2.5098 0 3.33543 0 4.35125C0 4.94051 0.292812 5.48738 0.783203 5.81414Z" fill="#013159" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4684_9370">
                                            <rect width="20" height="20" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg></a>
                                <p>Email</p>
                            </div>
                            <div className="single-icon">
                                <a href="#" onClick={(e) => handleCopyURL(e)}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <g clip-path="url(#clip0_4684_9376)">
                                        <path d="M12.2029 7.79613C11.966 7.55781 11.7033 7.34656 11.4198 7.16624C10.6687 6.68527 9.79545 6.4297 8.90354 6.4297C7.6656 6.42739 6.47796 6.91926 5.60413 7.79613L1.36489 12.0387C0.49255 12.9127 0.00224692 14.0969 0.00146581 15.3318C-0.000174521 17.9087 2.08742 19.9989 4.6643 20.0006C5.90033 20.0049 7.08687 19.5154 7.96039 18.6408L11.4598 15.1415C11.5233 15.0784 11.5588 14.9924 11.5583 14.9029C11.5573 14.7188 11.4072 14.5705 11.2231 14.5716H11.0898C10.3587 14.5741 9.63411 14.4337 8.95689 14.1583C8.83211 14.107 8.68869 14.1359 8.59363 14.2316L6.07741 16.7512C5.29606 17.5325 4.02926 17.5325 3.24791 16.7512C2.46657 15.9698 2.46657 14.703 3.24791 13.9217L7.50383 9.66911C8.28455 8.88937 9.54928 8.88937 10.33 9.66911C10.8562 10.1643 11.6769 10.1643 12.203 9.66911C12.4294 9.44255 12.5666 9.14206 12.5896 8.82259C12.6139 8.44082 12.4731 8.06694 12.2029 7.79613Z" fill="#013159" />
                                        <path d="M18.6319 1.36666C16.8097 -0.455553 13.8553 -0.455553 12.0331 1.36666L8.53703 4.85935C8.44103 4.95582 8.41334 5.10091 8.46704 5.22597C8.52012 5.35137 8.64416 5.43187 8.78031 5.42925H8.9036C9.63386 5.42792 10.3573 5.56942 11.0332 5.84585C11.158 5.89721 11.3014 5.86823 11.3965 5.77255L13.906 3.26632C14.6874 2.48497 15.9542 2.48497 16.7355 3.26632C17.5169 4.04766 17.5169 5.31447 16.7355 6.09581L13.6094 9.21857L13.5827 9.24856L12.4896 10.335C11.7089 11.1148 10.4441 11.1148 9.66343 10.335C9.13727 9.83986 8.31656 9.83986 7.79044 10.335C7.56263 10.5633 7.42528 10.8664 7.40383 11.1882C7.37946 11.57 7.52026 11.9439 7.79044 12.2147C8.1762 12.6021 8.62752 12.918 9.12353 13.1479C9.19351 13.1812 9.2635 13.2079 9.33349 13.2378C9.40348 13.2678 9.47678 13.2912 9.54677 13.3178C9.61676 13.3445 9.69006 13.3678 9.76005 13.3878L9.9567 13.4411C10.09 13.4744 10.2233 13.5011 10.3599 13.5244C10.5245 13.5489 10.6903 13.5645 10.8565 13.5711H11.0898H11.1098L11.3098 13.5478C11.3831 13.5445 11.4597 13.5278 11.5464 13.5278H11.6597L11.8897 13.4945L11.9963 13.4745L12.1896 13.4345H12.2263C13.0449 13.2289 13.7925 12.805 14.3892 12.208L18.6318 7.96547C20.4541 6.14326 20.4541 3.18887 18.6319 1.36666Z" fill="#013159" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4684_9376">
                                            <rect width="20" height="20" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg></a>
                                {
                                    copied ? <p>Copied!</p> :
                                        <p>Copy Link</p>
                                }
                            </div>

                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="modal_footer">
                        <button className="surebutton" onClick={handleClose3}>
                            OK
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal
                show={show4}
                onHide={handleClose4}
                className="modal_mainrr"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Create Dispute</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modalfst">
                        <h1>Message</h1>

                        <Form.Control
                            as="textarea"
                            placeholder="Enter your message here..."
                            style={{ height: "100px" }}
                        />
                        <h1>Upload File</h1>
                        <div className="modal3_inner">
                            <h2>Select File here</h2>
                            <p className="parssa">Files Supported : PDF, TEXT, DOC, DOCX</p>
                            <button className="ChooseFile">Choose File</button>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="modal_footer">
                        <button className="cancelbutton" onClick={handleClose}>
                            CANCEL
                        </button>
                        <button className="surebutton">SUBMIT</button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal
                show={show5}
                onHide={handleClose5}
                className="modal_mainr"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal4">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="70"
                            height="70"
                            viewBox="0 0 70 70"
                            fill="none"
                        >
                            <rect
                                x="5"
                                y="5"
                                width="60"
                                height="60"
                                stroke="#013159"
                                stroke-width="2"
                            />
                            <rect
                                x="28.2036"
                                y="49.8564"
                                width="2"
                                height="40.2235"
                                transform="rotate(-135 28.2036 49.8564)"
                                fill="#013159"
                            />
                            <rect
                                x="17"
                                y="38.625"
                                width="2"
                                height="15.43"
                                transform="rotate(-45 17 38.625)"
                                fill="#013159"
                            />
                        </svg>
                        <h1>Dispute created successfully</h1>
                        <p className="parssa">The DAO will review your request.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="modal_footer">
                        <button className="surebutton" onClick={handleClose5}>
                            OK
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal
                show={show6}
                onHide={handleClose6}
                className="modal_mainr"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Withdraw</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal4">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="70"
                            height="70"
                            viewBox="0 0 70 70"
                            fill="none"
                        >
                            <rect
                                x="5"
                                y="5"
                                width="60"
                                height="60"
                                stroke="#013159"
                                stroke-width="2"
                            />
                            <rect x="34" y="18" width="2" height="28" fill="#013159" />
                            <rect x="34" y="49" width="2" height="3" fill="#013159" />
                        </svg>
                        <h1>Are you sure you want to claim 100 TOMI for this task?</h1>
                        {/* <p className="parssa">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p> */}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="modal_footer">
                        <button className="cancelbutton" onClick={handleClose}>
                            CANCEL
                        </button>
                        <button className="surebutton" onClick={handleClose4}>
                            Yes, I’m Sure
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal
                className="newparticipate"
                show={show22}
                onHide={handleClose22}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Want to participate in a task?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mainboxinner">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                        >
                            <g clip-path="url(#clip0_1156_17963)">
                                <path
                                    d="M32.0002 17C32.0002 17.2652 31.8948 17.5196 31.7073 17.7071C31.5197 17.8946 31.2654 18 31.0002 18H29.0002V20C29.0002 20.2652 28.8948 20.5196 28.7073 20.7071C28.5197 20.8946 28.2654 21 28.0002 21C27.7349 21 27.4806 20.8946 27.2931 20.7071C27.1055 20.5196 27.0002 20.2652 27.0002 20V18H25.0002C24.7349 18 24.4806 17.8946 24.2931 17.7071C24.1055 17.5196 24.0002 17.2652 24.0002 17C24.0002 16.7348 24.1055 16.4804 24.2931 16.2929C24.4806 16.1054 24.7349 16 25.0002 16H27.0002V14C27.0002 13.7348 27.1055 13.4804 27.2931 13.2929C27.4806 13.1054 27.7349 13 28.0002 13C28.2654 13 28.5197 13.1054 28.7073 13.2929C28.8948 13.4804 29.0002 13.7348 29.0002 14V16H31.0002C31.2654 16 31.5197 16.1054 31.7073 16.2929C31.8948 16.4804 32.0002 16.7348 32.0002 17ZM24.7664 24.3562C24.9371 24.5595 25.0202 24.8222 24.9972 25.0866C24.9742 25.351 24.8471 25.5955 24.6439 25.7662C24.4407 25.937 24.178 26.02 23.9135 25.997C23.6491 25.974 23.4046 25.847 23.2339 25.6437C20.7189 22.6487 17.2614 21 13.5002 21C9.73891 21 6.28141 22.6487 3.76641 25.6437C3.59568 25.8468 3.35128 25.9737 3.08697 25.9966C2.82266 26.0194 2.5601 25.9364 2.35704 25.7656C2.15398 25.5949 2.02707 25.3505 2.00421 25.0862C1.98135 24.8219 2.06443 24.5593 2.23516 24.3562C4.10266 22.1337 6.42516 20.555 9.00641 19.71C7.43879 18.7336 6.23181 17.2733 5.56808 15.5498C4.90435 13.8264 4.81997 11.9337 5.32773 10.1581C5.83548 8.38242 6.90772 6.82045 8.38225 5.70847C9.85678 4.59649 11.6533 3.995 13.5002 3.995C15.347 3.995 17.1436 4.59649 18.6181 5.70847C20.0926 6.82045 21.1649 8.38242 21.6726 10.1581C22.1804 11.9337 22.096 13.8264 21.4322 15.5498C20.7685 17.2733 19.5615 18.7336 17.9939 19.71C20.5752 20.555 22.8977 22.1337 24.7664 24.3562ZM13.5002 19C14.7857 19 16.0425 18.6188 17.1114 17.9045C18.1803 17.1903 19.0134 16.1752 19.5054 14.9874C19.9974 13.7997 20.1261 12.4928 19.8753 11.2319C19.6245 9.97103 19.0054 8.81284 18.0964 7.9038C17.1873 6.99476 16.0291 6.37569 14.7683 6.12489C13.5074 5.87409 12.2004 6.00281 11.0127 6.49478C9.825 6.98675 8.80984 7.81987 8.09561 8.88879C7.38138 9.95771 7.00016 11.2144 7.00016 12.5C7.00215 14.2233 7.68761 15.8754 8.90616 17.094C10.1247 18.3126 11.7769 18.998 13.5002 19Z"
                                    fill="#013159"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_1156_17963">
                                    <rect width="32" height="32" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        <h3>Setup your Participant Profile</h3>
                        <p>
                            Complete your profile and get notified whenever a new task
                            relevant to your services is created.
                        </p>
                        <div className="lastbutton">
                            <Link to="/editprofile" className="setup text-center">
                                Setup Profile
                            </Link>
                            <button
                                onClick={() => {
                                    handleClose22();
                                    handleShow();
                                }}
                                className="skip"
                            >
                                Skip for now
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={showdispute}
                onHide={handleCloseDispute}
                className="modal_mainr"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Claim Reward</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="71" viewBox="0 0 70 71" fill="none">
                            <rect x="5" y="5.5" width="60" height="60" stroke="#013159" stroke-width="2" />
                            <rect x="24" y="19" width="2" height="22" transform="rotate(-90 24 19)" fill="#013159" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M35 19H37L37 12H35L35 19ZM35 58H37L37 53H44H46V51V36V34H44H26V17H24V34V36H26L44 36V51H37H35H24V53H35L35 58Z" fill="#013159" />
                        </svg>
                        <h1>
                            Important: Dispute Initiation Fee
                        </h1>
                        <p className="parssa">
                            Since the task value is high, any disputes will be carefully reviewed by a jury of 15 DOP Oracles to ensure a fair and accurate resolution. To support this process, initiating a dispute will require a fee of $400.
                            <br /><br />

                            Please take this into consideration before participating in a task, as you may incur this expense if a dispute arises.
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="modal_footer" style={{ flexDirection: "column-reverse", gap: "10px" }}>
                        <button className="cancelbutton m-0" onClick={handleCloseDispute}>
                            Cancel
                        </button>
                        <button
                            className="surebutton m-0"

                        >
                            Confirm Participation
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Reportmodal
                showReport={showReport} handleCloseReport={handleCloseReport}
                setLoader={setLoader}
            />
        </>
    );
};

export default Similartaskdetail;